import { render } from "./ComponenteGasPreciosManual.vue?vue&type=template&id=663e90d4&scoped=true"
import script from "./ComponenteGasPreciosManual.vue?vue&type=script&lang=js"
export * from "./ComponenteGasPreciosManual.vue?vue&type=script&lang=js"

import "./ComponenteGasPreciosManual.vue?vue&type=style&index=0&id=663e90d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663e90d4"]])

export default __exports__